import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import whatsappIcon from "../assets/whatsapp.png";

const WHATSAPP_HREF =
  "https://api.whatsapp.com/send?phone=+524611495564&text=%C2%A1Hola!%20Vengo%20de%20su%20p%C3%A1gina%20Web.";

const WhatsAppFloatingButton = () => {
  const location = useLocation();
  const [hasBottomRightCart, setHasBottomRightCart] = useState(false);

  useEffect(() => {
    const syncCartAnchor = () => {
      setHasBottomRightCart(Boolean(document.querySelector('[data-floating-cart-anchor="bottom-right"]')));
    };

    syncCartAnchor();

    const observer = new MutationObserver(syncCartAnchor);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["data-floating-cart-anchor"],
    });

    window.addEventListener("resize", syncCartAnchor);

    return () => {
      observer.disconnect();
      window.removeEventListener("resize", syncCartAnchor);
    };
  }, [location.pathname]);

  return (
    <a
      href={WHATSAPP_HREF}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Abrir WhatsApp"
      className={`fixed right-4 z-[39] inline-flex h-12 w-12 items-center justify-center overflow-hidden rounded-full p-0 shadow-[0_10px_24px_rgba(0,0,0,0.35)] transition-transform duration-200 hover:-translate-y-1 hover:brightness-105 md:right-8 md:h-16 md:w-16 ${
        hasBottomRightCart ? "bottom-[84px] md:bottom-[112px]" : "bottom-5 md:bottom-6"
      }`}
    >
      <img
        src={whatsappIcon}
        alt=""
        aria-hidden="true"
        className="h-full w-full rounded-full object-cover"
      />
    </a>
  );
};

export default WhatsAppFloatingButton;
